import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, ListChecks, ScrollText, Search,
  ShieldAlert, Siren, Server, Activity, Settings as SettingsIcon,
  FileText,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { NwsLogo } from "@/components/NwsLogo";

// Sidebar order is intentional. Top group ("decided") = what Tyrael has
// processed and surfaced. Middle group ("raw") = the data feeding it.
// Bottom group ("reference") = config and inventory. Customers should be
// able to do their day's work from the top group and dive into the rest
// only when investigating.
const NAV = [
  { to: "/dashboard",      label: "Dashboard",      icon: LayoutDashboard, group: "decided" },
  { to: "/findings",       label: "Findings",       icon: ListChecks,      group: "decided" },
  { to: "/audits",         label: "Audits",         icon: ScrollText,      group: "decided" },
  { to: "/investigations", label: "Investigations", icon: Search,          group: "decided" },
  { to: "/reports",        label: "Reports",        icon: FileText,        group: "decided" },
  { to: "/alerts",         label: "Flow alerts",    icon: ShieldAlert,     group: "raw" },
  { to: "/incidents",      label: "Incidents",      icon: Siren,           group: "raw" },
  { to: "/devices",        label: "Devices",        icon: Server,          group: "reference" },
  { to: "/data",           label: "Live data",      icon: Activity,        group: "reference" },
  { to: "/settings",       label: "Settings",       icon: SettingsIcon,    group: "reference" },
] as const;

export default function AppSidebar() {
  return (
    <aside className="hidden w-60 shrink-0 border-r border-border bg-card md:flex md:flex-col">
      <div className="flex h-16 items-center gap-3 border-b border-border bg-gradient-to-br from-primary/10 via-primary/5 to-transparent px-5">
        <NwsLogo className="h-7 w-7 text-primary" />
        <div className="leading-tight">
          <div className="text-sm font-semibold tracking-tight">Tyrael</div>
          <div className="whitespace-nowrap text-[10px] uppercase tracking-tight text-muted-foreground">
            CyberIntelligence
          </div>
        </div>
      </div>

      <nav className="flex-1 space-y-1 px-3 py-4">
        {NAV.map((item, i) => {
          const prev = NAV[i - 1];
          const showGroupBreak = prev !== undefined && prev.group !== item.group;
          const Icon = item.icon;
          return (
            <div key={item.to}>
              {showGroupBreak && <div className="my-2 border-t border-border/60" />}
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                    isActive
                      ? "bg-primary/10 text-primary"
                      : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                  )
                }
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            </div>
          );
        })}
      </nav>

      <div className="border-t border-border px-5 py-4 text-xs text-muted-foreground">
        <div className="font-medium text-foreground">v0.4</div>
        <div>Security Operations Center</div>
      </div>
    </aside>
  );
}
